import { Component, Inject } from '@angular/core';
import { helper } from 'src/environments/helper';
import { DocumentData, EntityDocument, GeneralData } from '../../../document.interface';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { catchError, debounceTime, distinctUntilChanged, finalize, map, Observable, of, Subject, switchMap, takeUntil, tap, throwError } from 'rxjs';
import { SearchEntitate } from 'src/app/components/entitati/entitati.interface';
import { Generic } from 'src/app/interfaces/generic.interface';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardService } from '../../../dashboard.service';
import { CommonService } from 'src/app/services/common.service';
import { NotificationService } from 'src/app/services/notification.service';
import Swal from 'sweetalert2';
import { formatDate } from '@angular/common';

@Component({
    selector: 'app-edit-emitent-extern',
    templateUrl: './edit-emitent-extern.component.html',
    styleUrls: ['./edit-emitent-extern.component.scss']
})
export class EditEmitentExternComponent {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;
    helper = helper;

    isLoading = false;

    docData: DocumentData | null = null;

    defaultTaraId: number | null = null;
    defaultTaraLabel = '';
    defaultJudetId: number | null = null;
    defaultJudetLabel = '';
    defaultLocalitateId: number | null = null;
    defaultLocalitateLabel = '';

    defaultParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    form: FormGroup = new FormGroup({
        serie_pv: new FormControl('', []),
        extern_numar: new FormControl('', []),
        extern_date_input: new FormControl('', []),
        // extern_date: new FormControl('', []), // Added in submitForm!
        data_comunicare_pv_input: new FormControl('', []),
        // data_comunicare_pv: new FormControl('', []), // Added in submitForm!
    });

    formExtern: FormGroup = new FormGroup({
        type: new FormControl(1, []), // Hard coded emitent
        id: new FormControl(null, []),
        denumire: new FormControl('', []),
        email: new FormControl('', []),
        telefon: new FormControl('', []),
        id_tara: new FormControl(this.defaultTaraId, []),
        name_tara: new FormControl(this.defaultTaraLabel, []),
        id_judet: new FormControl(this.defaultJudetId, []),
        name_judet: new FormControl(this.defaultJudetLabel, []),
        id_localitate: new FormControl(this.defaultLocalitateId, []),
        name_localitate: new FormControl(this.defaultLocalitateLabel, []),
        sector: new FormControl('-1', []),
        id_strada: new FormControl(null, []),
        name_strada: new FormControl('', []),
        numar: new FormControl('', []),
        bloc: new FormControl('', []),
        scara: new FormControl('', []),
        apartament: new FormControl('', []),
        cod_postal: new FormControl('', []),
        observatii: new FormControl('', []),
    })

    private destroy$ = new Subject<void>();

    entitatiExtern: SearchEntitate[] = [];
    entitatiExternControl = new FormControl();
    isEntitatiExternLoading = false;
    showEntitatiExternMessage = true;
    entitatiExternLoadComplete = false;

    tariExtern: Generic[] = [];
    filteredTariExtern: Generic[] = [];
    tariExternControl = new FormControl();

    judeteExtern: Generic[] = [];
    filteredJudeteExtern: Generic[] = [];
    judeteExternControl = new FormControl();

    localitatiExtern: Generic[] = [];
    localitatiExternControl = new FormControl();
    isLocalitatiExternLoading = false;
    showLocalitatiExternMessage = true;
    localitatiExternLoadComplete = false;

    straziExtern: Generic[] = [];
    straziExternControl = new FormControl();
    isStraziExternLoading = false;
    showStraziExternMessage = true;
    straziExternLoadComplete = false;
    lastStraziExternValue = '';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            generalData: GeneralData[],
            docData: DocumentData,
        },
        private dialogRef: MatDialogRef<EditEmitentExternComponent>,
        private dashboardService: DashboardService,
        private commonService: CommonService,
        private notificationService: NotificationService,
    ) {
        this.data.generalData.forEach(item => {
            if (item.name === 'default_adresa_tara' && Number(item.value) > 0 && item.label) {
                this.defaultTaraId = Number(item.value);
                this.defaultTaraLabel = item.label || '';
            } else if (item.name === 'default_adresa_judet' && Number(item.value) > 0 && item.label) {
                this.defaultJudetId = Number(item.value);
                this.defaultJudetLabel = item.label || '';
            } else if (item.name === 'default_adresa_localitate' && Number(item.value) > 0 && item.label) {
                this.defaultLocalitateId = Number(item.value);
                this.defaultLocalitateLabel = item.label || '';
            }
        })

        this.docData = data.docData;
    }

    ngOnInit() {
        this.loadTariActive();

        if (this.docData) {
            this.form.controls['serie_pv'].patchValue(this.docData.serie_pv);
            this.form.controls['extern_numar'].patchValue(this.docData.extern_numar);
            if (this.docData.extern_date) this.form.controls['extern_date_input'].patchValue(new Date(this.docData.extern_date));
            if (this.docData.data_comunicare_pv) this.form.controls['data_comunicare_pv_input'].patchValue(new Date(this.docData.data_comunicare_pv));

            // Update emitent extern with docData
            if (this.docData.entity_emitent_extern) this.updateFormEmitentExtern(this.docData.entity_emitent_extern);
            // Load default locatie extern, if we don't have an address
            if (!this.docData.entity_emitent_extern?.id_tara) this.loadDefaultLocatieExtern();
        }

        this.entitatiExternControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(value => {
            if (typeof value === 'string') {
                this.fetchEntitatiExtern(value);
                this.showEntitatiExternMessage = true;
                this.entitatiExternLoadComplete = false;
            }
        });

        this.localitatiExternControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(localitate => {
            if (typeof localitate === 'string') {
                this.fetchLocalitatiExtern(localitate);
                this.showLocalitatiExternMessage = true;
                this.localitatiExternLoadComplete = false;
            }
        });

        this.straziExternControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(strada => {
            if (typeof strada === 'string') {
                this.fetchStraziExtern(strada);
                this.showStraziExternMessage = true;
                this.straziExternLoadComplete = false;
            }
        });

        this.renderFieldsSearch();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }


    // START -- Methods for getting data -- START
    renderFieldsSearch() {
        this.tariExternControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.tariExtern);
                }
                if (inputValue.length < 1) {
                    this.filteredTariExtern = this.tariExtern;
                    return of(this.tariExtern);
                }
                return this.filterTariExtern(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredTariExtern = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.judeteExternControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.judeteExtern);
                }
                if (inputValue.length < 1) {
                    this.filteredJudeteExtern = this.judeteExtern;
                    return of(this.judeteExtern);
                }
                return this.filterJudeteExtern(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredJudeteExtern = data;
            }),
            catchError(() => of([]))
        ).subscribe();
    }

    loadTariActive() {
        this.isLoading = true;
        this.commonService
            .getTariActive()
            .pipe(
                takeUntil(this.destroy$),
                map((resp: Generic[]) => [...resp]),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.tariExtern = results;

                    this.filteredTariExtern = [...this.tariExtern];
                },
                error: (error) => {
                    console.error('Error loading tari', error);
                    this.filteredTariExtern = [];
                },
            });
    }

    fetchEntitatiExtern(entitate: string) {
        if (entitate && entitate.length >= 2) {
            this.isEntitatiExternLoading = true;
            this.commonService.searchEntitatiExtern(entitate).subscribe({
                next: (response: SearchEntitate[]) => {
                    this.entitatiExtern = response;
                    this.isEntitatiExternLoading = false;
                    this.entitatiExternLoadComplete = true;
                    this.showEntitatiExternMessage = this.entitatiExtern.length === 0;
                },
                error: (err: any) => {
                    this.isEntitatiExternLoading = false;
                    this.showEntitatiExternMessage = true;
                    this.entitatiExternLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.entitatiExtern = [];
            this.showEntitatiExternMessage = true;
            this.entitatiExternLoadComplete = false;
        }
    }

    onEntitateExternSelected(selectedEntitate: SearchEntitate) {
        if (selectedEntitate) {
            this.updateFormEmitentExtern(selectedEntitate);
        }
    }

    displayEntitateExtern(entitate: SearchEntitate): string {
        return entitate && entitate.denumire ? entitate.denumire : '';
    }

    onEntitateExternChange() {
        const currentValue = this.entitatiExternControl.value;

        if (typeof currentValue === 'string') {
            // this.formExtern.controls['id'].patchValue(null); // No id reset when updating entity
            this.formExtern.controls['denumire'].patchValue(currentValue);
        }
    }

    updateFormEmitentExtern(selectedEntitate: SearchEntitate | EntityDocument) {
        this.entitatiExternControl.setValue(selectedEntitate);
        this.formExtern.get('id')?.patchValue(selectedEntitate.id);
        this.formExtern.get('denumire')?.patchValue(selectedEntitate.denumire);
        this.formExtern.get('email')?.patchValue(selectedEntitate.email);
        this.formExtern.get('telefon')?.patchValue(selectedEntitate.telefon);

        if (selectedEntitate.id_tara && selectedEntitate.name_tara) {
            this.tariExternControl.setValue({
                id: selectedEntitate.id_tara,
                name: selectedEntitate.name_tara
            })
            this.formExtern.get('id_tara')?.patchValue(selectedEntitate.id_tara);
            this.formExtern.get('name_tara')?.patchValue(selectedEntitate.name_tara);
            this.loadJudeteExtern(selectedEntitate.id_tara);
        }
        if (selectedEntitate.id_judet && selectedEntitate.name_judet) {
            this.judeteExternControl.setValue({
                id: selectedEntitate.id_judet,
                name: selectedEntitate.name_judet
            })
            this.formExtern.get('id_judet')?.patchValue(selectedEntitate.id_judet);
            this.formExtern.get('name_judet')?.patchValue(selectedEntitate.name_judet);
        }
        if (selectedEntitate.id_localitate && selectedEntitate.name_localitate) {
            this.fetchLocalitatiExtern(selectedEntitate.name_localitate);
            this.localitatiExternControl.setValue({
                id: selectedEntitate.id_localitate,
                name: selectedEntitate.name_localitate
            })
            this.formExtern.get('id_localitate')?.patchValue(selectedEntitate.id_localitate);
            this.formExtern.get('name_localitate')?.patchValue(selectedEntitate.name_localitate);
        }
        if (selectedEntitate.id_strada && selectedEntitate.name_strada) {
            this.fetchStraziExtern(selectedEntitate.name_strada);
            this.straziExternControl.setValue({
                id: selectedEntitate.id_strada,
                name: selectedEntitate.name_strada
            })
            this.formExtern.get('id_strada')?.patchValue(selectedEntitate.id_strada);
            this.formExtern.get('name_strada')?.patchValue(selectedEntitate.name_strada);
        }

        this.formExtern.get('sector')?.patchValue(selectedEntitate.sector);
        this.formExtern.get('numar')?.patchValue(selectedEntitate.numar);
        this.formExtern.get('bloc')?.patchValue(selectedEntitate.bloc);
        this.formExtern.get('scara')?.patchValue(selectedEntitate.scara);
        this.formExtern.get('apartament')?.patchValue(selectedEntitate.apartament);
        this.formExtern.get('cod_postal')?.patchValue(selectedEntitate.cod_postal);

        this.formExtern.get('observatii')?.patchValue(selectedEntitate.observatii);
    }

    onTariExternChange(selectedTara: Generic): void {
        this.formExtern.controls['id_tara'].patchValue(selectedTara.id);
        this.formExtern.controls['name_tara'].patchValue(selectedTara.name);

        this.loadJudeteExtern(selectedTara.id);
        this.judeteExternControl.patchValue('');
        this.formExtern.controls['id_judet'].patchValue('');
        this.formExtern.controls['name_judet'].patchValue('');

        this.localitatiExternControl.patchValue('');
        this.formExtern.controls['id_localitate'].patchValue('');
        this.formExtern.controls['name_localitate'].patchValue('');

        this.straziExternControl.patchValue('');
        this.formExtern.controls['id_strada'].patchValue('');
        this.formExtern.controls['name_strada'].patchValue('');
    }

    displayTariExtern(selectedTara: Generic): string {
        return selectedTara && selectedTara.name ? selectedTara.name : '';
    }

    onTariExternBlur() {
        const currentValue = this.tariExternControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.tariExternControl.patchValue('');
            this.formExtern.controls['id_tara'].patchValue('');
            this.formExtern.controls['name_tara'].patchValue('');

            this.judeteExtern = [];
            this.filteredJudeteExtern = [];
            this.judeteExternControl.patchValue('');
            this.formExtern.controls['id_judet'].patchValue('');
            this.formExtern.controls['name_judet'].patchValue('');

            this.localitatiExternControl.patchValue('');
            this.formExtern.controls['id_localitate'].patchValue('');
            this.formExtern.controls['name_localitate'].patchValue('');

            this.straziExternControl.patchValue('');
            this.formExtern.controls['id_strada'].patchValue('');
            this.formExtern.controls['name_strada'].patchValue('');
        }
    }

    loadJudeteExtern(taraId?: number) {
        this.isLoading = true;
        this.commonService
            .getJudeteActive(taraId)
            .pipe(
                takeUntil(this.destroy$),
                map((resp: Generic[]) => [...resp]),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.judeteExtern = results;
                    this.filteredJudeteExtern = results;
                },
                error: (error) => {
                    console.error('Error loading judete', error);
                    this.filteredJudeteExtern = [];
                },
            });
    }

    onJudeteExternChange(selectedJudet: Generic): void {
        this.formExtern.controls['id_judet'].patchValue(selectedJudet.id);
        this.formExtern.controls['name_judet'].patchValue(selectedJudet.name);

        this.localitatiExternControl.patchValue('');
        this.formExtern.controls['id_localitate'].patchValue('');
        this.formExtern.controls['name_localitate'].patchValue('');

        this.straziExternControl.patchValue('');
        this.formExtern.controls['id_strada'].patchValue('');
        this.formExtern.controls['name_strada'].patchValue('');
    }

    displayJudeteExtern(selectedJudet: Generic): string {
        return selectedJudet && selectedJudet.name ? selectedJudet.name : '';
    }

    onJudeteExternBlur() {
        const currentValue = this.judeteExternControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.judeteExternControl.patchValue('');
            this.formExtern.controls['id_judet'].patchValue('');
            this.formExtern.controls['name_judet'].patchValue('');

            this.localitatiExternControl.patchValue('');
            this.formExtern.controls['id_localitate'].patchValue('');
            this.formExtern.controls['name_localitate'].patchValue('');

            this.straziExternControl.patchValue('');
            this.formExtern.controls['id_strada'].patchValue('');
            this.formExtern.controls['name_strada'].patchValue('');
        }
    }

    fetchLocalitatiExtern(localitate: string) {
        const taraExternValue = this.formExtern.get('id_tara')?.value;
        const judetExternValue = this.formExtern.get('id_judet')?.value;
        const tara = taraExternValue && taraExternValue !== -1 ? this.formExtern.get('id_tara')?.value : undefined;
        const judet = judetExternValue && judetExternValue !== -1 ? this.formExtern.get('id_judet')?.value : undefined;
        if (localitate.length >= 2) {
            this.isLocalitatiExternLoading = true;
            this.commonService.getLocalitatiActive(tara, judet, localitate).subscribe({
                next: (response: any) => {
                    this.localitatiExtern = response;
                    this.isLocalitatiExternLoading = false;
                    this.localitatiExternLoadComplete = true;
                    this.showLocalitatiExternMessage = this.localitatiExtern.length === 0;
                },
                error: (err: any) => {
                    this.isLocalitatiExternLoading = false;
                    this.showLocalitatiExternMessage = true;
                    this.localitatiExternLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.localitatiExtern = [];
            this.showLocalitatiExternMessage = true;
            this.localitatiExternLoadComplete = false;
        }
    }

    onLocalitatiExternSelected(selectedLocalitate: Generic) {
        if (selectedLocalitate) {
            this.formExtern.controls['id_localitate'].patchValue(selectedLocalitate.id);
            this.formExtern.controls['name_localitate'].patchValue(selectedLocalitate.name);
        }
    }

    displayLocalitatiExtern(selectedLocalitate: Generic): string {
        return selectedLocalitate && selectedLocalitate.name ? selectedLocalitate.name : '';
    }

    onLocalitatiExternBlur() {
        const currentValue = this.localitatiExternControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.localitatiExternControl.patchValue('');
            this.formExtern.controls['id_localitate'].patchValue('');
            this.formExtern.controls['name_localitate'].patchValue('');

            this.straziExternControl.patchValue('');
            this.formExtern.controls['id_strada'].patchValue('');
            this.formExtern.controls['name_strada'].patchValue('');
        }
    }

    fetchStraziExtern(strada: string) {
        this.fetchStraziExternObservable(strada).subscribe();
    }

    private fetchStraziExternObservable(strada: string) {
        const taraExternValue = this.formExtern.get('id_tara')?.value;
        const judetExternValue = this.formExtern.get('id_judet')?.value;
        const localitateExternValue = this.formExtern.get('id_localitate')?.value;
        const tara = taraExternValue && taraExternValue !== -1 ? taraExternValue : undefined;
        const judet = judetExternValue && judetExternValue !== -1 ? judetExternValue : undefined;
        const localitate = localitateExternValue && localitateExternValue !== -1 ? localitateExternValue : undefined;

        if (strada.length >= 2) {
            this.lastStraziExternValue = strada;
            this.isStraziExternLoading = true;

            return this.commonService.getStraziActive(tara, judet, localitate, strada).pipe(
                takeUntil(this.destroy$),
                tap((response: any) => {
                    this.straziExtern = response;
                    this.isStraziExternLoading = false;
                    this.straziExternLoadComplete = true;
                    this.showStraziExternMessage = this.straziExtern.length === 0;
                }),
                catchError((err: any) => {
                    this.isStraziExternLoading = false;
                    this.showStraziExternMessage = true;
                    this.straziExternLoadComplete = true;
                    console.log(err);
                    return throwError(() => err);
                })
            );
        } else {
            this.straziExtern = [];
            this.showStraziExternMessage = true;
            this.straziExternLoadComplete = false;
            return of([]);
        }
    }

    onStraziExternSelected(selectedStrada: Generic) {
        if (selectedStrada) {
            this.formExtern.controls['id_strada'].patchValue(selectedStrada.id);
            this.formExtern.controls['name_strada'].patchValue(selectedStrada.name);
        }
    }

    displayStraziExtern(selectedStrada: Generic): string {
        return selectedStrada && selectedStrada.name ? selectedStrada.name : '';
    }

    onStraziExternBlur() {
        setTimeout(() => {
            const currentValue = this.straziExternControl.value;

            // If the value is a string (not an object), it means user didn't select from list
            if (typeof currentValue === 'string') {
                this.straziExternControl.patchValue('');
                this.formExtern.controls['id_strada'].patchValue('');
                this.formExtern.controls['name_strada'].patchValue('');
                this.lastStraziExternValue = '';
            }
        }, 2000)
    }

    addStraziExtern() {
        this.isLoading = true;
        const payload = {
            name: this.lastStraziExternValue,
            id_country: this.formExtern.get('id_tara')?.value,
            id_judet: this.formExtern.get('id_judet')?.value,
            id_localitate: this.formExtern.get('id_localitate')?.value,
        }

        // console.log(payload);
        this.commonService.storeStrada(payload)
            .pipe(
                switchMap(() => this.fetchStraziExternObservable(this.lastStraziExternValue)),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: () => {
                    // Run fetchStraziExtern first then fill the input with the new street data
                    if (this.straziExtern && this.straziExtern.length > 0) {
                        const foundStrada = this.straziExtern[0];
                        this.straziExternControl.setValue(foundStrada);
                        this.formExtern.controls['id_strada'].patchValue(foundStrada.id);
                        this.formExtern.controls['name_strada'].patchValue(foundStrada.name);
                    }
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            })
    }

    normalizeString(value: string): string {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    }

    filterTariExtern(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.tariExtern.filter(tara =>
            this.normalizeString(tara.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterJudeteExtern(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.judeteExtern.filter(judet =>
            this.normalizeString(judet.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }
    // END -- Methods for getting data -- END


    loadDefaultLocatieExtern() {
        this.tariExternControl.setValue({
            id: this.defaultTaraId,
            name: this.defaultTaraLabel
        })
        if (this.defaultTaraId) {
            this.loadJudeteExtern(this.defaultTaraId);
            this.judeteExternControl.setValue({
                id: this.defaultJudetId,
                name: this.defaultJudetLabel
            })
        }
        if (this.defaultJudetLabel) {
            this.fetchLocalitatiExtern(this.defaultJudetLabel);
            this.localitatiExternControl.setValue({
                id: this.defaultLocalitateId,
                name: this.defaultLocalitateLabel
            })
        }

        this.formExtern.patchValue({
            id_tara: this.defaultTaraId,
            name_tara: this.defaultTaraLabel,
            id_judet: this.defaultJudetId,
            name_judet: this.defaultJudetLabel,
            id_localitate: this.defaultLocalitateId,
            name_localitate: this.defaultLocalitateLabel,
        })
    }

    submitForm() {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'Vă rugăm să confirmați acest proces!',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.updateDoc();
            }
        });
    }

    updateDoc() {
        this.isLoading = true;

        const extern_date_input = this.form.value.extern_date_input;
        const data_comunicare_pv_input = this.form.value.data_comunicare_pv_input;

        const payload = {
            ...this.form.value,
            extern_date: extern_date_input ? formatDate(extern_date_input, 'yyyy-MM-dd', 'en-US') : '',
            data_comunicare_pv: data_comunicare_pv_input ? formatDate(data_comunicare_pv_input, 'yyyy-MM-dd', 'en-US') : '',
            ...this.formExtern.value,
        };

        // console.log(payload);
        this.dashboardService
            .updateEmitentExtern(this.docData!.id_document, payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    Swal.fire({
                        title: helper.dialogConfig.headers.success,
                        text: 'Emitent Extern - Documentație actualizată cu succes',
                        icon: 'success',
                        confirmButtonText: this.helper.dialogConfig.buttonLabels.close,
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.dialogRef.close({ success: true });
                        }
                    });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
